import DownloadFormPopupEmail from './download-form-popup-email';
import DownloadFormPopupPassword from './download-form-popup-password';

class ButtonDownloadHandler {
  private formDownloadPopupEmail: DownloadFormPopupEmail;
  private formDownloadPopupPw: DownloadFormPopupPassword;

  constructor() {
    this.formDownloadPopupEmail = new DownloadFormPopupEmail();
    this.formDownloadPopupPw = new DownloadFormPopupPassword();
  }

  init() {
    const elButtons = document.querySelectorAll('button.js-download-button');
    if (elButtons.length > 0) {
      this.formDownloadPopupEmail.init();
      this.formDownloadPopupPw.init();
      elButtons.forEach((el) => {
        el.addEventListener('click', () => this.onClickButton(el as HTMLElement));
      });
    }
  }

  private onClickButton(el: HTMLElement) {
    const idFile = el.dataset.id || '';
    const slugFile = el.dataset.slug || '';
    const filename = el.dataset.filename;
    const fileImage = el.dataset.image || '';
    const lang = el.dataset.lang || '';
    const popupTarget = el.dataset.target;
    const downloadType = el.dataset.downloadType || null;
    let popupContent = null;
    const popupElement = document.querySelector('#popup-email .m-popup__content') as HTMLElement;
    console.log('image', fileImage);
    if (downloadType && downloadType === '16831') {
      if (popupElement && popupElement.dataset.contentCatalog) popupContent = JSON.parse(popupElement.dataset.contentCatalog);
    } else {
      if (popupElement && popupElement.dataset.contentOther) popupContent = JSON.parse(popupElement.dataset.contentOther);
    }

    const storage = JSON.parse(window.localStorage.getItem('downloaded') || '[]');
    const download = {selector: idFile, date: new Date()};

    switch (popupTarget) {
      case 'popup-email':
        let fileImages = [];
        try {
          fileImages = JSON.parse(fileImage);
        } catch (e) {
          fileImages = [];
        }

        if (fileImages.length > 0) {
          this.formDownloadPopupEmail.setData(idFile, lang, fileImages, null, popupContent);
        } else if (fileImage !== '') {
          this.formDownloadPopupEmail.setData(idFile, lang, [fileImage], null, popupContent);
        } else {
          this.formDownloadPopupEmail.setData(idFile, lang, [], null, popupContent);
        }
        this.formDownloadPopupEmail.setCallback(() => {
          storage.push(download);
          window.localStorage.setItem('downloaded', JSON.stringify(storage));
        });
        break;

      case 'popup-password':
        if (filename) {
          this.formDownloadPopupPw.setData(idFile, lang, [], filename);
        } else {
          this.formDownloadPopupPw.setData(idFile, lang);
        }
        this.formDownloadPopupEmail.setCallback(() => {
          storage.push(download);
          window.localStorage.setItem('downloaded', JSON.stringify(storage));
        });
        break;

      case 'none':
        storage.push(download);
        window.localStorage.setItem('downloaded', JSON.stringify(storage));

        const apiBaseUrl = document.body.dataset.apiBaseUrl;
        let directDownloadUrl = apiBaseUrl + 'download/' + slugFile + '?lang=' + lang;
        // @ts-ignore
        let newWindow = window.open(directDownloadUrl, '_blank');
        // @ts-ignore
        newWindow.focus();

        if (filename) {
          // @ts-ignore
          newWindow.document.title = filename;
        }
        break;

      default:
        break;
    }
  }
}

export default ButtonDownloadHandler;
